export default "__VITE_ASSET__CMF$fh9t__"